/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharTTLOCriteriaInput
 */
export interface CharTTLOCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof CharTTLOCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CharTTLOCriteriaInput
     */
    value?: string;
}

export function CharTTLOCriteriaInputFromJSON(json: any): CharTTLOCriteriaInput {
    return CharTTLOCriteriaInputFromJSONTyped(json, false);
}

export function CharTTLOCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharTTLOCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CharTTLOCriteriaInputToJSON(value?: CharTTLOCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


